<template>
  <refresh type="discount">
    <rollbox
      :offText="transify['CHANGE_OFF']"
      @startReel="$bus.drawing=true"
      @stopReel="$bus.drawing=false"
      ref="rollbox"
    ></rollbox>
  </refresh>
</template>
<script>
  import { mapState } from '@/utils/assist'
  import Rollbox from '@/components/rollbox/rollbox'
  import Refresh from '@/components/refresh/refresh'
  export default {
    name: 'DiscountRefresh',
    computed: {
      ...mapState(['transify', 'discount', 'uid']),
      firstRollKey() {
        return `${this.uid}_${PROJECT_NAME}_firstRoll`
      },
    },
    data() {
      return {}
    },
    components: {
      Rollbox,
      Refresh,
    },
    methods: {
      roll() {
        if (localStorage.getItem(this.firstRollKey) !== 'true') {
          this.$refs.rollbox.start()
          this.$refs.rollbox.stop(this.discount)
          localStorage.setItem(this.firstRollKey, 'true')
        } else {
          this.$refs.rollbox.setPosition(this.discount)
        }
      },
    },
    mounted() {
      this.$bus.discountEl = this.$refs.rollbox
      this.roll()
    },
  }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/discount-refresh/discount-refresh.vue